<div *ngIf="show"
     class="retentionBadge"
     [class.expired]="expired"
     [class.compact]="compact"
     [nbPopover]="retentionPopover"
     nbPopoverTrigger="hover"
     nbPopoverPlacement="bottom">
	<nb-icon icon="alert-triangle-outline" class="retentionIcon"></nb-icon>
	<span class="retentionDays">{{daysLabel}}</span>
</div>

<ng-template #retentionPopover>
	<div class="retentionTooltip">
		<div class="retentionTitle" *ngIf="retention.lastTariffName">Тариф {{retention.lastTariffName}} закінчився</div>
		<div class="retentionTitle" *ngIf="!retention.lastTariffName">Підписку призупинено</div>

		<div class="retentionRow" *ngIf="retention.daysLeft > 0">
			Через <b>{{retention.daysLeft}} дн.</b> ({{retention.gracePeriodEndsAt | date:'dd.MM.yyyy'}}) термін зберігання Ваших записів та відео завершиться.
		</div>
		<div class="retentionRow" *ngIf="retention.daysLeft <= 0">
			Термін зберігання Ваших записів вичерпано.
		</div>

		<div class="retentionRow" *ngIf="admin && retention.gbAtRisk > 0">
			Об'єм під ризиком: <b>{{retention.gbAtRisk | number:'1.1-1'}} ГБ</b>
		</div>

		<div class="retentionRow noticeRow" *ngIf="admin && noticesTooltip">
			<small>{{noticesTooltip}}</small>
		</div>

		<div class="retentionCta">
			Активуйте тариф у кабінеті — і записи залишаться доступними.
		</div>
	</div>
</ng-template>
